import { createContext, useContext, useState } from "react";

const EnteredContext = createContext();

const EnteredProvider = ({ children }) => {
  const [entered, setEntered] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [selected, setSelected] = useState(null);

  const valid = ["AB2", "BC4", "DB3", "AD1", "BA3", "DC1", "AC4", "BD2", "CB4"];

  const addEntered = (value) => {
    if (!disabled) {
      if (entered.length > 2) {
        setEntered("");
      }
      setEntered((prevEntered) => prevEntered + value);
    }
  };

  const validateSelected = () => {
    if (valid.indexOf(selected) !== -1) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <EnteredContext.Provider
      value={{
        selected,
        setSelected,
        entered,
        setEntered,
        addEntered,
        disabled,
        setDisabled,
        validateSelected,
      }}
    >
      {children}
    </EnteredContext.Provider>
  );
};

export { EnteredContext, EnteredProvider };
